import {AbstractList} from "./abstract-list";

export class QueueTaskList extends AbstractList {
  constructor(item: HTMLElement) {
    super(item);
  }

  addNewTasks(selector: string) {
    const newItems = this.item.querySelectorAll(selector);
    this.items = this.item.querySelectorAll(`.js-task-item, ${selector}`);

    return newItems;
  }
}
